/* eslint-disable react/prop-types */
import { Grid, TextField, Typography } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Autocomplete } from "@material-ui/lab";
import React from "react";

const useStyles = makeStyles(() => ({
  header: {
    border: `1px solid #dadce0`,
    padding: 16,
    wordWrap: "break-word",
    pageBreakInside: "avoid",
    background: "#fff",
    borderRadius: 8,
    borderTopWidth: 10,
    borderTopColor: `rgb(158, 158, 158)`,
  },
  box: {
    border: `1px solid #dadce0`,
    padding: 16,
    wordWrap: "break-word",
    pageBreakInside: "avoid",
    background: "#fff",
    borderRadius: 8,
  },
}));

const InputBox = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const {
    title,
    placeholder = "Your Answer",
    type,
    options,
    onChange,
    id,
    required = false,
    getOptionLabel,
    getReturnValue,
    value,
    helperText = "",
    disabled = false,
  } = props;
  return (
    <>
      <Grid
        item
        container
        className={classes.box}
        direction="column"
        alignItems="stretch"
      >
        <Grid item>
          <Typography component="span" style={{ fontSize: 16 }}>
            {title}
          </Typography>
          {required && (
            <Typography
              component="span"
              style={{
                fontSize: 16,
                marginLeft: 8,
                color: theme.palette.error.main,
              }}
            >
              *
            </Typography>
          )}
        </Grid>
        <Grid item style={{ marginTop: 16 }}>
          {type != "dropdown" ? (
            <TextField
              disabled={disabled}
              helperText={helperText}
              required={required}
              id={id}
              style={{ fontSize: 14 }}
              placeholder={placeholder}
              fullWidth
              value={value && value}
              onChange={(e) => onChange && onChange(id, e.target.value)}
            />
          ) : (
            <Autocomplete
              options={options}
              id={id}
              // value={averageBy}
              getOptionLabel={(option) =>
                getOptionLabel ? getOptionLabel(option) : option.label
              }
              style={{ minWidth: 200 }}
              onChange={(event, newValue) => {
                onChange &&
                  onChange(
                    id,
                    newValue
                      ? getReturnValue
                        ? getReturnValue(newValue)
                        : newValue
                      : null
                  );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={placeholder}
                  required={required}
                />
              )}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default InputBox;
